import { useEffect, useState } from 'react';
import styles from 'styles/modules/DateProgress.module.scss';
import CrosshatchLine from 'components/CrosshatchLine';
import { getDatePercentageDifference } from 'helpers/getDatePercentageDifference';

const DateProgress = ({ createdAt, deadline, height, isFTEditor }) => {
    if (!deadline || !createdAt) {
        return null;
    }
    const [width, setWidth] = useState(
        getDatePercentageDifference(createdAt, deadline)
    );

    useEffect(() => {
        setWidth(getDatePercentageDifference(createdAt, deadline));
        const interval = setInterval(() => {
            setWidth(getDatePercentageDifference(createdAt, deadline));
        }, 60000);
        return () => {
            clearInterval(interval);
        };
    }, [createdAt, deadline]);

    return (
        <div className={styles.progressWrapper}>
            <CrosshatchLine style={{ height }} className={styles.line} />
            <div
                className={[
                    styles.progress,
                    isFTEditor ? styles.ftEditorProgress : '',
                ].join(' ')}
                style={{ width, height }}
            />
        </div>
    );
};

export default DateProgress;
